import { render, staticRenderFns } from "./Decisionofvacation.vue?vue&type=template&id=6b002afb&scoped=true&"
import script from "./Decisionofvacation.vue?vue&type=script&lang=ts&"
export * from "./Decisionofvacation.vue?vue&type=script&lang=ts&"
import style0 from "./Decisionofvacation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Decisionofvacation.vue?vue&type=style&index=1&id=6b002afb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b002afb",
  null
  
)

component.options.__file = "Decisionofvacation.vue"
export default component.exports